import axios from "axios";

export default {
    getPrices(_) {
        return axios.get('/api/pricing/getprices');
    },
    getEmployeeCount(_) {
        return axios.get("/api/pricing/getregisteremployeecount");
    },

    startSubscription(_, params) {
        return axios.post("/api/iyzicopayment/startsubscription", params, {withCredentials: true});
    },

    startSinglePayment(_, params) {
        return axios.post("/api/iyzicopayment/startsinglepayment", params, {withCredentials: true});
    }
};
